import { memo } from 'react';
import styled, { css } from 'styled-components';
import { TitleCell } from '../title-cell';

interface NameCellProps {
  name?: { firstName?: string; lastName?: string };
  firstName?: string;
  lastName?: string;
  fullName?: string;
  subtitle?: string;
  color?: string;
  showInitials?: boolean;
}

const NameCell = ({
  name,
  subtitle,
  color,
  showInitials = true,
  ...props
}: NameCellProps) => {
  const splitFullName = props.fullName?.split(' ');
  const firstName =
    name?.firstName ?? props.firstName ?? splitFullName?.[0] ?? '';
  const lastName = name?.lastName ?? props.lastName ?? splitFullName?.[1] ?? '';

  if (!firstName && !lastName) {
    return;
  }

  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  return (
    <Wrapper>
      {showInitials && <Initials>{initials}</Initials>}
      <TitleCell
        title={`${firstName} ${lastName}`}
        subtitle={subtitle}
        color={color}
      />
    </Wrapper>
  );
};

export default memo(NameCell);

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1.5)};
  `}
`;

const Initials = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.spacing(3)};
    min-width: ${theme.spacing(3)};
    height: ${theme.spacing(3)};
    border-radius: ${theme.borderRadius.sm};
    background-color: ${theme.palette.neutral[50]};
    border: 0.5px solid ${theme.palette.neutral[80]};
    color: ${theme.palette.neutral[90]};
    ${theme.typography.bodySm2};
  `}
`;
